<template>
  <!-- relative contains the absolutely-positioned sr-only span; without it the
       span escapes overflow-x scroll containers and widens the page. -->
  <button
    type="button"
    class="relative rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
    :class="colorClasses"
    @click="emit('click', $event)"
  >
    <span class="sr-only">Close</span>
    <XMarkIcon :class="iconSizeClasses(props.size)" aria-hidden="true" />
  </button>
</template>

<script setup>
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { computed } from 'vue'
import { iconSizeClasses } from '../common'

const props = defineProps({
  dark: Boolean,
  size: {
    type: String,
    default: 'lg',
  },
})

const emit = defineEmits(['click'])

const colorClasses = computed(() =>
  props.dark
    ? 'text-gray-400 hover:text-gray-300'
    : 'text-gray-400 hover:text-gray-500 dark:hover:text-gray-300'
)
</script>
